import { useEffect, useState } from "react"
import BeneficiaryEsmScreen from "../../screen/GenerateBeneficiaryEsmScreen"
import { useScope } from "../SelectProjectCompanyContainer"
import { customToast } from "../../components/Toast"
import { useParams } from "react-router-dom"
import Send from "../../core/communication"
import { calculateAccumulatedAverages, formatEsmData } from "../ESMContainer"
import moment from "moment"
import { useUsers } from "../../core/utils/hooks/useUsers"

export const dividirTextoPorAcoes = (texto, limite = 2000) => {
  // Pré-processa o texto
  const textoFormatado = texto
    .replace(/^###\s*/gm, '')                         // Remove títulos com ###
    .replace(/\*\*(.*?)\*\*/g, '$1')                  // Remove negritos **
    .replace(/^- /gm, '')                             // Remove traços no início das linhas
    .replace(/^\s+/gm, '')                            // Remove espaços em branco extras
    .trim();

  // Divide em blocos de ações com base nos números (ex: "1. ...", "2. ...")
  const acoes = textoFormatado.split(/\n(?=\d+\.\s)/g);

  // Envolve cada item com <p> e adiciona <br> após o título numerado
  const acoesComParagrafos = acoes.map(acao => {
    const formatado = acao.replace(/^(\d+\.\s[^\n]+)\n?/, '$1<br>\n');
    return `<p>${formatado.trim()}</p>\n`;
  });

  const resultado = [];
  let atual = '';

  for (const acao of acoesComParagrafos) {
    if ((atual + acao).length > limite) {
      resultado.push(atual.trim());
      atual = acao;
    } else {
      atual += acao;
    }
  }

  if (atual.trim().length > 0) {
    resultado.push(atual.trim());
  }

  return resultado;
};

const BeneficiaryEsmContainer = () => {
  const { scope, scopeType } = useScope()
  const { userId } = useParams()
  const { users } = useUsers()
  const [scalesUser, setScalesUser] = useState({})
  const [scaleId, setScaleId] = useState(null)
  const [openGenerateEsmBeneficiary, setOpenGenerateEsmBeneficiary] = useState(false)
  const [actionPlan, setActionPlan] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleOpenGenerateEsmBeneficiary = () => {
    loadEsmData()
  }

  const handleCloseGenerateEsmBeneficiary = () => {
    setOpenGenerateEsmBeneficiary(false)
    setActionPlan(null)
  }

  const loadScales = async () => {
    try {
      const scales = await Send.get(`/scale-producer/user/${userId}`)

      if (scales?.data && scales?.data?.scale) {

        const { scale } = scales?.data

        setScaleId(scale[0]?.id)
      }
    } catch (error) {
      console.log(error)
      customToast("Erro ao buscar esm", "error")
    }
  }

  const loadEsmData = async () => {
    setLoading(true)
    try {
      let esm = await Send.get(
        `/scale-indicator/allesm/user/${userId}/scale/${scaleId}`
      )

      const { dataToReturn } = formatEsmData(esm, users)

      // Ordena por data (mais recente primeiro)
      const sortedData = dataToReturn.sort(
        (a, b) => moment(a.date, "DD/MM/YYYY").unix() - moment(b.date, "DD/MM/YYYY").unix(),
      )

      // Filtra usuários únicos, mantendo o item mais recente
      const uniqueUsers = Array.from(
        new Map(sortedData.map((item) => [item.userId, item])).values(),
      )

      setScalesUser(uniqueUsers)
    } catch (error) {
      console.error("Erro ao buscar esm", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (scope?.id) {
      loadScales()
    }
  }, [scope])

  useEffect(() => {
    if(scalesUser.length > 0){
      setOpenGenerateEsmBeneficiary(true)
    }
  }, [scalesUser])

  const fetchActionPlan = async () => {
    setLoading(true)

    const criterios = scalesUser[0].fields.map(({ title, concept, value, variables }) => ({
      title,
      concept,
      value,
      variables,
    }))

    try {
      const response = await fetch("https://api.openai.com/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer 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`,
        },
        body: JSON.stringify({
          model: "gpt-4o",
          messages: [
            {
              role: "user",
              content:
                "O sistema possui uma escala de 0 a 100 para identificar o índice de sustentabilidade, dessa forma, gere um plano de ação para aumentar os critérios encontrados: " +
                JSON.stringify({
                  criterios,
                }),
            },
          ],
          // max_tokens: 16000,
          temperature: 0.7,
        }),
      })

      const data = await response.json()

      setActionPlan(dividirTextoPorAcoes(data.choices[0].message?.content, 2200) || null)
    } catch (error) {
      console.error("Error fetching action plan:", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <BeneficiaryEsmScreen
      {...{
        scaleId,
        scalesUser,
        scope,
        actionPlan,
        loadingActionPlan: loading,
        handleOpenGenerateEsmBeneficiary,
        handleCloseGenerateEsmBeneficiary,
        openGenerateEsmBeneficiary,
      }}
    />
  )
}

export default BeneficiaryEsmContainer
